import gql from 'graphql-tag';

export const updateCoverageHours = gql`
  mutation updateCoverageHours($input: InputUpdateCoverageHours!) {
    updateCoverageHours(input: $input) {
      id
      routingId
      teamId
      dayOfWeek
      startMinute
      endMinute
      timezone
    }
  }
`;
